export default {
  ja:[
    "本人確認書類",
    "表面",
    "裏面",
    "有効は証明書は \n・免許証（両面） \n・パスポート\n・マイナンバーカード\n・住民票ID\n・日本住民票/特別永住者証明書、外国人登録証\nになります。",
    "※jpeg, png, 10MBまで",
    "画像送信済み",
  ],
  en: [
    "Your self verification",
    "Verification document (front): ",
    "Verification document (back):",
    "Passport/Passport Card, Drivers license \n— scans of front and back are required, \nID card (by U.S. state) — scans of front and back are required, \nResident permit ID/U.S. Green Card/North Carolina Resident ID, \nBorder Crossing Card, \nChild ID card, \nNYC Card, \nU.S. visa card",
    "※jpeg, png, up to 10MB",
    "Image sent",,
  ]
}
